<div class="gototop1 go-top go-top3 active">
    <i class="fa fa-angle-up" aria-hidden="true"></i>
</div>